module.exports = __webpack_public_path__ + "static/media/tape.2351b02a.jpg";